import ErrorCircle from '../../../../general/icon/components/error-circle';

type ErrorMessageProps = {
  message: string;
};

import styles from './error-message.module.scss';

export const ErrorMessage = ({ message }: ErrorMessageProps) => (
  <div className={styles['error-message']}>
    <div className={styles['error-message__content']}>
      <div className={styles['error-message__icon-wrapper']}>
        <div className={styles['error-message__icon']}>
          <ErrorCircle />
        </div>
      </div>
      <div className={styles['error-message__text-wrapper']}>
        <div
          className={styles['error-message__text']}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
    </div>
  </div>
);
